import { render, staticRenderFns } from "./SitesDetails.vue?vue&type=template&id=f60bd74a&scoped=true&"
import script from "./SitesDetails.vue?vue&type=script&lang=js&"
export * from "./SitesDetails.vue?vue&type=script&lang=js&"
import style0 from "./SitesDetails.vue?vue&type=style&index=0&id=f60bd74a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60bd74a",
  null
  
)

component.options.__file = "SitesDetails.vue"
export default component.exports